var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoteOwnerOutlinedHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49057 2.70042L7.92919 3.502L8.36783 2.70043C8.6103 2.25733 9.01413 1.66454 9.607 1.20603L9.30635 0.817289L9.607 1.20603C10.2169 0.734364 10.8988 0.5 11.646 0.5C13.7338 0.5 15.3584 2.20135 15.3584 4.56902C15.3584 5.82224 14.8622 6.89787 13.9163 8.03925C12.9577 9.19591 11.5764 10.3752 9.8549 11.8422L9.8549 11.8423L9.85466 11.8425C9.27463 12.3368 8.61514 12.8988 7.92922 13.4986C7.24372 12.8992 6.58454 12.3374 6.00507 11.8436L6.00389 11.8426L6.00388 11.8426C4.2822 10.3754 2.90077 9.19598 1.94216 8.03928C0.996229 6.89787 0.5 5.82224 0.5 4.56902C0.5 2.20135 2.12458 0.5 4.21239 0.5C4.95966 0.5 5.64154 0.734364 6.25141 1.20603L6.5573 0.810513L6.25141 1.20603C6.84428 1.66454 7.24811 2.2573 7.49057 2.70042Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteOwnerOutlinedHeart);
export default __webpack_public_path__ + "static/media/vote_owner_outlined_heart.e47687549f0ff29e54bc15fb795a5aec.svg";
export { ForwardRef as ReactComponent };